import { actionCreator } from 'utils';
import * as FormTypes from '../types/formTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    offset: 0,
    limit: 50,
    sort: {
        key: 'shipping_date',
        type: 'asc',
    },
    filters: {
        form_number: '',
        quality: '',
        sizes: '',
        order_id: '',
        order_item_id: '',
        form_version_id: '',
        shippingDate: [],
        design_id: '',
        customer: '',
        state: undefined,
        reprint: undefined,
        withBorder: undefined,
        rollType: undefined,
        segment_repetition: undefined,
    },
    deleteForm: null,
    update: {
        loading: false,
        success: false,
        error: false,
    },
    checked: [],
};

export default function (state = initState, action) {
    switch (action.type) {
    case FormTypes.LOAD_FORMS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(FormTypes.LOAD_FORMS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(FormTypes.LOAD_FORMS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case FormTypes.SET_FORM_FILTERS:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case FormTypes.SET_FORM_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case FormTypes.SET_FORM_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case FormTypes.RESET_FORM_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case FormTypes.DELETE_FORM:
        return Object.assign({}, state, {
            deleteForm: action.data.formId,
        });

    case actionCreator(FormTypes.DELETE_FORM, 'res'):
        return Object.assign({}, state, {
            deleteForm: null,
        });

    case actionCreator(FormTypes.DELETE_FORM, 'err'):
        return Object.assign({}, state, {
            deleteForm: null,
        });

    case FormTypes.UPDATE_FORM:
        return Object.assign({}, state, {
            update: {
                ...state.update,
                loading: action.data.form_id,
                success: false,
                error: false,
            },
        });

    case actionCreator(FormTypes.UPDATE_FORM, 'res'):
        return Object.assign({}, state, {
            update: {
                ...state.update,
                loading: action.loading,
                success: action.success,
            },
        });

    case actionCreator(FormTypes.UPDATE_FORM, 'err'):
        return Object.assign({}, state, {
            update: {
                ...state.update,
                loading: false,
                success: false,
                error: true,
            },
        });

    case FormTypes.SET_CHECKED_FORMS:
        return Object.assign({}, state, {
            checked: action.ids,
        });

    default:
        return state;
    }
}
